export const InvalidDiscountImageResourcesEn = {
    invalidDiscountText: "Archived offer",
    goActiveOffers: "Go to active offers",
};
